import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../components/layouts/dashboardLayout'
import { Breadcrumb } from 'react-bootstrap';
import RLDD from 'react-list-drag-and-drop/lib/RLDD';
import Offcanvas from 'react-bootstrap/Offcanvas';
import AddBrand from '../../components/forms/addBrand';
import AppApi from "../../api/app";
import toast from 'react-hot-toast';
import { useSelector, useDispatch } from 'react-redux';
import Actions from '../../store/actions';
import { AiOutlineEdit } from "react-icons/ai";
import AddSlider from '../../components/forms/AddSlider';
import { addIdToData } from '../../utils';


let updateInterval = ""

function Sliders() {
   let sliders = useSelector(data => data.profile?.data?.landingPage?.sliders || []);
   sliders = addIdToData(sliders);
   // let profile = useSelector(data => data.profile?.data);
   let dispatch = useDispatch();

   const [show, setShow] = useState(false);

   const [slider, setSlider] = useState({});



   let updateBrandsListOrder = (list) => {
      try {
         AppApi.updateBrandsListOrder({ brands: list })
            .then(async (res) => {
               if (res?.status == 200) {
                  toast.success("Brands order list updated successfully.");
               }
            })
            .catch((error) => {
               console.log(error.message)
               if (error?.response?.data?.msg) {
                  toast.error(error?.response?.data?.msg);
               } else {
                  toast.error("Brands list updating failed error.");
               }
            });
      } catch (error) {
         console.log(error.message);
         toast.error("Services temporary down. Please try later.");
      }
   }
   let updateList = async (data, remove = false) => {
      let list = sliders;
      if (remove) {
         list = list.filter(item => item._id != data._id);
      } else {
         if (slider?._id) {
            let index = await list.findIndex(item => item?._id == data._id);
            if (index > -1) {
               list[index] = data
            }
         } else {
            list = [...list, data]
         }
      }
      list = await addIdToData(list);
      console.log(list)
      dispatch(Actions.updateSliderList(list));
      setShow(false);
   }

   let editSlider = (data) => {
      setSlider(data)
      setShow(true)
   }

   return (
      <>
         <DashboardLayout>
            <div className="container-fluid mt-4">
               <div className="row">
                  <div className="col-12">
                     <Breadcrumb>
                        <Breadcrumb.Item href="#">
                           Dashboard
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active>Banner Sliders</Breadcrumb.Item>
                     </Breadcrumb>
                  </div>
               </div>

               <div className="row">
                  <div className="col-12">
                     <div className="p-3 overflow-hidden">
                        <div className="d-flex justify-content-between border-bottom pb-2">
                           <div>
                              <h4>Banner Sliders</h4>
                           </div>
                           <div>
                              <button className='btn rounded-0 btn-dark'
                                 onClick={() => editSlider({})}
                              >Add New</button>
                           </div>
                        </div>
                        <br />
                        <div className="listedWrapper">
                           <RLDD
                              items={sliders}
                              itemRenderer={(data, index) => {
                                 return (
                                    <div className='sliderCardWrapper border rounded overflow-hidden position-relative'>
                                       <div className='imageWrapper'>
                                          {data?.image ? (
                                             <img src={data?.image} alt="Slider" className="w-100 h-100 object-fit-cover" />
                                          ) : (
                                             <div className="placeholder-image d-flex align-items-center justify-content-center h-100">
                                                <span className="text-muted">No Image</span>
                                             </div>
                                          )}

                                          <div className='actionButtons position-absolute top-0 end-0 m-2'>
                                             <button
                                                className='btn btn-light btn-sm me-2'
                                                onClick={() => editSlider(data)}
                                             >
                                                <AiOutlineEdit />
                                             </button>

                                             <a
                                                className='btn btn-light btn-sm'
                                                href={data?.link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                             >
                                                View
                                             </a>
                                          </div>

                                          <div className='status-badge position-absolute bottom-0 start-0 m-2'>
                                             <span className={`badge ${data?.isActive ? 'bg-success' : 'bg-danger'}`}>
                                                {data?.isActive ? 'Active' : 'Inactive'}
                                             </span>
                                          </div>
                                       </div>
                                    </div>
                                 );
                              }}
                              onChange={(data) => {
                                 console.log(data)
                                 // dispatch(Actions.addBrandsList(data));
                                 if (updateInterval) {
                                    clearTimeout(updateInterval);
                                 }
                                 updateInterval = setTimeout(() => {
                                    // updateBrandsListOrder(data);
                                    toast.error("This feature is not available. Please try later.")
                                 }, 2000);
                              }}
                           />
                        </div>
                     </div>
                  </div>
               </div>

            </div>
         </DashboardLayout>
         <Offcanvas show={show} placement="end" onHide={() => setShow(false)}>
            <Offcanvas.Header closeButton>
               <Offcanvas.Title>Add Brand</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
               <AddSlider updateList={updateList} slider={slider} />
            </Offcanvas.Body>
         </Offcanvas>
      </>
   )
}

export default Sliders